import { ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'ez-forgot-password',
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordComponent {
  recaptchaPublicKey: string = '';
  errorMessage: string = '';
  loginUrl: string = '';

  readonly #fb = inject(FormBuilder);
  form;

  constructor(elementRef: ElementRef) {
    const getAttribute = elementRef.nativeElement.getAttribute.bind(elementRef.nativeElement);

    this.recaptchaPublicKey = getAttribute('recaptcha-public-key');
    this.errorMessage = getAttribute('error-message');
    this.loginUrl = getAttribute('login-url');

    this.form = this.#fb.group({
      username: ['', Validators.required],
    });

    const queryString = window.location.search.toLowerCase();
    const urlParams = new URLSearchParams(queryString);
    const username = urlParams.get('username');

    if (username) {
      this.form.patchValue({ username });
    }
  }
}
